import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Bloc } from 'src/app/models/bloc.model';
import { Conjunt } from 'src/app/models/conjunt.model';
import { Observacio } from 'src/app/models/observacio.model';
import { Questionari } from 'src/app/models/questionari.model';
import { ModalService } from 'src/app/services/modal.service';
import { RumiService } from 'src/app/services/rumi.service';
import { UtilitatsService } from 'src/app/services/utilitats.service';

@Component({
  selector: 'app-inici-simulacio',
  templateUrl: './inici-simulacio.component.html'
})
export class IniciSimulacioComponent implements OnInit, OnDestroy {

  readonly TIPUS_INFANT_NASCITURUS = '0';
  readonly TIPUS_INFANT_NADO = '1';
  readonly TIPUS_INFANT_ADOLESCENT = '2';

  readonly SEXE_DONA = 'Dona';
  readonly SEXE_HOME = 'Home';

  public iniciSimulacioForm: FormGroup;
  public errors: Array<string> = [];

  public get ambits() {
    return this.rumiService.ambits;
  }

  public get unitats_edat_estimada(){
    return this.rumiService.unitats_edat_estimada;
  }

  constructor(
    public translate: TranslateService,
    private router: Router,
    private _fb: FormBuilder,
    private rumiService: RumiService,
    public modal: ModalService,
    private utilService: UtilitatsService
  ) { }

  ngOnInit() {
    this.rumiService.pestanyaActiva = this.router.url;
    this.initIniciSimulacioForm();
  }

  ngOnDestroy(): void {
    this.sync();
  }

  private initIniciSimulacioForm() {

    this.iniciSimulacioForm = this._fb.group({
      ambit: [this.rumiService.simulacio.ambitSeleccionat, []],
      tipus: [this.rumiService.simulacio.tipusSeleccionat, []],
      sexe: [this.rumiService.simulacio.sexeSeleccionat, []],
      tipus_edat: [this.rumiService.simulacio.tipusEdatSeleccionat, []],
      data: [this.rumiService.simulacio.dataSeleccionada, []],
      edat: [this.rumiService.simulacio.edatSeleccionada, []],
      unitat_edat_estimada: [this.rumiService.simulacio.unitatEdatEstimadaSeleccionada, []]
    });

    this.iniciSimulacioForm.get('tipus').valueChanges.subscribe(value => {
      switch (value) {
        case this.TIPUS_INFANT_NASCITURUS:
          this.iniciSimulacioForm.get('tipus_edat').disable();
          this.iniciSimulacioForm.get('data').disable();
          this.iniciSimulacioForm.get('edat').disable();
          this.iniciSimulacioForm.get('unitat_edat_estimada').disable();

          this.iniciSimulacioForm.get('tipus_edat').setValue('');
          this.iniciSimulacioForm.get('data').setValue('');
          this.iniciSimulacioForm.get('edat').setValue(-1);
          this.iniciSimulacioForm.get('unitat_edat_estimada').setValue('');
          break;
        case this.TIPUS_INFANT_NADO:
          this.iniciSimulacioForm.get('tipus_edat').disable();
          this.iniciSimulacioForm.get('data').enable();
          this.iniciSimulacioForm.get('edat').disable();
          this.iniciSimulacioForm.get('unitat_edat_estimada').disable();   

          this.iniciSimulacioForm.get('tipus_edat').setValue('');
          this.iniciSimulacioForm.get('data').setValue('');
          this.iniciSimulacioForm.get('edat').setValue(null);
          this.iniciSimulacioForm.get('unitat_edat_estimada').setValue('');
          break;
        case this.TIPUS_INFANT_ADOLESCENT:
          this.iniciSimulacioForm.get('tipus_edat').enable();
          this.iniciSimulacioForm.get('data').disable();
          this.iniciSimulacioForm.get('edat').disable();
          this.iniciSimulacioForm.get('unitat_edat_estimada').disable();  

          this.iniciSimulacioForm.get('tipus_edat').setValue('');
          this.iniciSimulacioForm.get('data').setValue('');
          this.iniciSimulacioForm.get('edat').setValue(null);
          this.iniciSimulacioForm.get('unitat_edat_estimada').setValue('');
          break;
      }
    });

    this.iniciSimulacioForm.get('tipus_edat').valueChanges.subscribe(value => {
        this.habilitaDeshabilitaCamps();
        this.iniciSimulacioForm.get('data').setValue('');
        this.iniciSimulacioForm.get('edat').setValue(null);
        this.iniciSimulacioForm.get('unitat_edat_estimada').setValue('');
    });

    this.habilitaDeshabilitaCamps();

  }

  habilitaDeshabilitaCamps() {
    if (this.iniciSimulacioForm.get('tipus_edat').value == 'data_exacta') {
      this.iniciSimulacioForm.get('data').enable();
      this.iniciSimulacioForm.get('edat').disable();
      this.iniciSimulacioForm.get('unitat_edat_estimada').disable();
    } else if (this.iniciSimulacioForm.get('tipus_edat').value == 'edat_estimada') {
      this.iniciSimulacioForm.get('data').disable();
      this.iniciSimulacioForm.get('edat').enable();
      this.iniciSimulacioForm.get('unitat_edat_estimada').enable();
    }
  }
  goToNextStep() {
    this.validar();
    if (this.errors.length > 0) {
      this.modal.open('errors');
    } else {
      this.sync();
      this.utilService.showSpinner('Carregant dades...');
      this.rumiService.getBlocs().subscribe((res: Questionari) => {
        this.utilService.hideSpinner();
        var teAlgunaObservacio = false;
        if(res.blocs != null){          
          res.blocs.forEach(bloc => {
            bloc.conjunts.forEach(conjunt => {
              teAlgunaObservacio = true;
              conjunt.observacionsDisponibles = conjunt.observacions;
              conjunt.observacions = [];
              conjunt.ordreGravetat = conjunt.idGravetat;
              conjunt.idGravetat = 0;
              conjunt.observacionsDisponibles.sort(this.compareObservacions);    
              conjunt.numAltresObservacions = 0;
            });
            bloc.conjunts.sort(this.compareConjunts);
          });       
          if(teAlgunaObservacio) {
            this.recuperarInformacioBlocs(this.rumiService.simulacio.blocs, res.blocs);
          }
        }
        this.rumiService.simulacio.blocs = res.blocs;
        this.rumiService.simulacio.teAlgunaObservacio = teAlgunaObservacio;
        this.router.navigate(['simulacio', 'questionari-observacions']);
      });
    }
  }

  private recuperarInformacioBlocs(blocsAntics: Array<Bloc>, blocsNous: Array<Bloc>){
    blocsNous.forEach(blocNou => {
      blocNou.conjunts.forEach(conjuntNou => {
        blocsAntics.forEach(blocAntic => {
          blocAntic.conjunts.forEach(conjuntAntic => {              
            if(blocNou.id == blocAntic.id && conjuntNou.id == conjuntAntic.id){
              if(conjuntAntic.idGravetat != null){
                conjuntNou.idGravetat = conjuntAntic.idGravetat;
              }
              if(conjuntAntic.observacionsProposades != null){
                conjuntNou.observacionsProposades = conjuntAntic.observacionsProposades;
                conjuntNou.numAltresObservacions = conjuntAntic.numAltresObservacions;
              }
              if(conjuntAntic.observacions != null){
                conjuntNou.observacions = [];
                conjuntAntic.observacions.forEach(observacioAntigaSeleccionada => {
                  conjuntNou.observacionsDisponibles.forEach((observacioDisponibleNova, index) => {
                    if(observacioAntigaSeleccionada.id == observacioDisponibleNova.id){
                      conjuntNou.observacions.push(observacioDisponibleNova);
                      conjuntNou.observacionsDisponibles.splice(index, 1);
                    }
                  });
                });
              }
            }
          });          
        });           
      }); 
    });
  }

  compareConjunts(conjunt1: Conjunt, conjunt2: Conjunt) {
    if (parseInt(conjunt1.descripcio.split(".")[0].substr(1)) > parseInt(conjunt2.descripcio.split(".")[0].substr(1))) {
      return 1;
    }
    if (parseInt(conjunt1.descripcio.split(".")[0].substr(1)) < parseInt(conjunt2.descripcio.split(".")[0].substr(1))) {
      return -1;
    }
    return 0;
  }

  compareObservacions(observacio1: Observacio, observacio2: Observacio) {
    if (parseInt(observacio1.descripcio.split(".")[1]) > parseInt(observacio2.descripcio.split(".")[1])) {
      return 1;
    }
    if (parseInt(observacio1.descripcio.split(".")[1]) < parseInt(observacio2.descripcio.split(".")[1])) {
      return -1;
    }
    return 0;
  }

  goToPrevStep() {
    this.sync();
    this.router.navigate(['home']);
  }

  sync() {
    if(this.rumiService.simulacio != null) {
      this.rumiService.simulacio.ambitSeleccionat = this.iniciSimulacioForm.get('ambit').value;
      this.rumiService.simulacio.tipusSeleccionat = this.iniciSimulacioForm.get('tipus').value;
      this.rumiService.simulacio.sexeSeleccionat = this.iniciSimulacioForm.get('sexe').value;
      this.rumiService.simulacio.tipusEdatSeleccionat = this.iniciSimulacioForm.get('tipus_edat').value;
      this.rumiService.simulacio.dataSeleccionada = this.iniciSimulacioForm.get('data').value;
      this.rumiService.simulacio.edatSeleccionada = this.iniciSimulacioForm.get('edat').value;
      this.rumiService.simulacio.unitatEdatEstimadaSeleccionada = this.iniciSimulacioForm.get('unitat_edat_estimada').value;
    }
  }

  navigate(url: String) {
    this.router.navigate([url]);
  }

  calcularEdatByDataNaixement(data: string) {
    var date = new Date();
    var naixement = new Date(data);
    var edat = date.getFullYear() - naixement.getFullYear();
    var m = date.getMonth() - naixement.getMonth();

    if (m < 0 || (m === 0 && date.getDate() < naixement.getDate())) {
      edat--;
    }
    return edat;
  }  

  majorNumAnys(data: string, anys: number) {
    var date = new Date(data);
    return (this.compararData((date.getFullYear()+anys)+'-'+(date.getMonth()+1)+'-'+date.getDate()) < 0);
  }

  compararData(data1: string, data2?: string) {
    var date1 = new Date(data1);
    var date2 = new Date();
    if (data2 != null) date2 = new Date(data2);
    if (date1.getFullYear()==date2.getFullYear() && date1.getMonth() == date2.getMonth() && date1.getDate() == date2.getDate()) return 0;
    if (date1.getFullYear()<date2.getFullYear()) return -1;
    if (date1.getFullYear()>date2.getFullYear()) return 1;
    if (date1.getMonth()<date2.getMonth()) return -1;
    if (date1.getMonth()>date2.getMonth()) return 1;
    if (date1.getDate()<date2.getDate()) return -1;
    return 1;
  }

  validar() {
    let datePattern = /^\d{4}\-\d{1,2}\-\d{1,2}$/;

    this.errors = [];
    if (this.iniciSimulacioForm.get('ambit').value == '') {
      this.errors.push("És obligatori informar el camp 'Àmbit d'actuació'");
    }

    if (this.iniciSimulacioForm.get('tipus').value == '') {
      this.errors.push("És obligatori informar el tipus d'infant");

    } else if (this.iniciSimulacioForm.get('tipus').value == this.TIPUS_INFANT_NADO) {

      if (this.iniciSimulacioForm.get('sexe').value == '') {
        this.errors.push("És obligatori informar el 'Sexe'");
      }

      if (this.iniciSimulacioForm.get('data').value == '') {
        this.errors.push("És obligatori informar la 'Data exacta'");

      } else if (!this.iniciSimulacioForm.get('data').value.match(datePattern)) {
        this.errors.push("La data del camp 'Data exacta' ha de ser vàlida, en format dd/mm/aaaa");

      } else if(this.compararData(this.iniciSimulacioForm.get('data').value)==1){
        this.errors.push("La data del camp 'Data exacta' no pot ser una data futura");
        
      }else if (this.majorNumAnys(this.iniciSimulacioForm.get('data').value, 1)) {
        this.errors.push("El nadó no pot tenir més d'un any. Cal introduir-lo com a infant o adolescent");
      }

    } else if (this.iniciSimulacioForm.get('tipus').value == this.TIPUS_INFANT_ADOLESCENT) {//Infant/Adolescent

      if (this.iniciSimulacioForm.get('sexe').value == '') {
        this.errors.push("És obligatori informar el 'Sexe'");
      }

      if (this.iniciSimulacioForm.get('tipus_edat').value == '') {
        this.errors.push("És obligatori informar tipus data");

      } else if (this.iniciSimulacioForm.get('tipus_edat').value == 'data_exacta') {

        if (this.iniciSimulacioForm.get('data').value == '') {
          this.errors.push("És obligatori informar la 'Data exacta'");

        } else if (!this.iniciSimulacioForm.get('data').value.match(datePattern)) {
          this.errors.push("La data del camp 'Data exacta' ha de ser vàlida, en format dd/mm/aaaa");

        } else if(this.compararData(this.iniciSimulacioForm.get('data').value) == 1){
          this.errors.push("La data del camp 'Data exacta' no pot ser una data futura");
          
        } else if (this.majorNumAnys(this.iniciSimulacioForm.get('data').value, 17)){
          this.errors.push("L'infant o adolescent no pot ser major de 17 anys");
        }

      } else if (this.iniciSimulacioForm.get('tipus_edat').value == 'edat_estimada') {

        if (this.iniciSimulacioForm.get('edat').value == '') {
          this.errors.push("És obligatori informar 'l'Edat estimada'");

        } else if(parseInt(this.iniciSimulacioForm.get('edat').value) <= 0){
          this.errors.push("El camp 'Edat estimada' ha de tenir un valor superior a 0");

        }

        if (this.iniciSimulacioForm.get('unitat_edat_estimada').value == '') {
          this.errors.push("És obligatori seleccionar la 'Unitat de l'edat estimada'");
        }

        if (this.iniciSimulacioForm.get('unitat_edat_estimada').value == '26' && parseInt(this.iniciSimulacioForm.get('edat').value) > 17) {
          this.errors.push("L'infant o adolescent no pot ser major de 17 anys");
        }
      }
    }
  }
}
